import native from '@zz-common/native-adapter'

const records = []

const invoke = (method, params, callback) => {
  const startTime = new Date().getTime()
  const id = `${startTime}_${Math.ceil(Math.random() * 1000)}`
  startRecord(id, startTime, method)
  // 处理params是函数，且callback不存在的特殊情况，这种构造的hybrid api应该不多
  if (callback && typeof callback === 'function') {
    // 对回调方法进行二次包装，当回调执行完成后，记录一下回调完成
    const fn = (res) => {
      callback && callback(res)
      endRecord(id)
    }
    native.wrap(method)(params, fn)
  } else if (!callback && params && typeof params === 'function') {
    // params直接是回调的情况
    const fn = (res) => {
      params(res)
      endRecord(id)
    }
    native.wrap(method)(fn)
  } else if (!callback && params && params.callback && typeof params.callback === 'function') {
    // 回调放在params中的情况
    // login 方法适合此场景
    const fn = (res) => {
      params.callback(res)
      endRecord(id)
    }
    native.wrap(method)(fn, callback)
  } else {
    // 没有传回调的情况
    const fn = () => endRecord(id)
    native.wrap(method)(params, fn)
  }
}
// import(/* webpackChunkName: "native-adapter" */ '@zz-common/native-adapter').then((native) => {
//   native.default && native.default.wrap(method)(params, callback)
// })

// 开始记录native方法的调用
const startRecord = (id, startTime, method) => {
  records.push({
    id, // hybrid方法的id，也是执行hybrid方法的开始时间
    startTime, // 执行hybrid方法的开始时间
    method // hybrid方法的方法名
  })
}

// 记录native方法开始返回
const endRecord = (id) => {
  setTimeout(() => {
    records.some((item) => {
      if (item.id === id) {
        const endTime = new Date().getTime()
        item.endTime = endTime // hybrid方法执行的结束时间
        item.cost = endTime - item.startTime // hybrid方法的执行耗时
        // log('常规记录日志')
        return true
      }
      return false
    })
  }, 0) // 将本次记录操作，放在操作队列的队尾进行执行
}

const allApisReturned = () => {
  const timeout = 2000 // 本方法的超时时间
  const loopRate = 30 // 每30毫秒循环检查一次
  return new Promise((resolve) => {
    const start = new Date().getTime()
    const intervalId = setInterval(() => {
      const end = new Date().getTime()
      if (end - start >= timeout) {
        log('allApisReturned 超时结束日志')
        // resolve()
        clearInterval(intervalId)
      } else {
        if (records.every((item) => item.cost)) {
          log('allApisReturned 正常结束日志')
          resolve()
          clearInterval(intervalId)
        }
      }
    }, loopRate)
  })
}

const log = (msg) => {
  let logStr = `========${msg}=========\r`
  records.forEach((item) => {
    logStr += `${item.id}...${item.method}...${item.cost}ms\r`
  })
  console.warn(logStr)
}

export default {
  invoke,
  allApisReturned,
  log
}
